import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';
import hasPermission from '../../../../Shared/hasPermission';

const SearchPartnerOfferingsToggle = ({ styles = {} }) => {
    // bool tied to the Search Partner Offerings toggle in the text search section
    const searchPartnerOfferings = useSelector(state => state.practice.searchPartnerOfferings);

    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(actions.practice.setSearchPartnerOfferings(!searchPartnerOfferings))
    }, [searchPartnerOfferings, dispatch]);

    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canSearchPartnerOfferingIds = can('SearchPartnerOfferingIds');

    if(!canSearchPartnerOfferingIds) return [];
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={searchPartnerOfferings}
            label='Search Partner Offerings'
        />
    );
};

export default SearchPartnerOfferingsToggle;
